import { render, staticRenderFns } from "./volunteersVoucher.vue?vue&type=template&id=37dcc2ac&scoped=true&"
import script from "./volunteersVoucher.vue?vue&type=script&lang=js&"
export * from "./volunteersVoucher.vue?vue&type=script&lang=js&"
import style0 from "./volunteersVoucher.vue?vue&type=style&index=0&id=37dcc2ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dcc2ac",
  null
  
)

export default component.exports